import React, { Component } from 'react';
import { Button, Card, List, Row, Col, Statistic } from 'antd';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import { getIncuBaseList } from '@store/modules/incubator/incubator_list';
import '../incubator.less';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    this.props.dispatch(getIncuBaseList());
  };

  render() {
    const { data } = this.props;
    return (
      <div className="incubatorList">
        <Link to="/incubator/base/add">
          <Button type="primary" style={{ marginBottom: '16px' }}>
            新增
          </Button>
        </Link>
        <List
          grid={{
            gutter: 16,
            xs: 3,
            sm: 3,
            md: 3,
            xl: 3,
            xxl: 4,
          }}
          dataSource={data}
          renderItem={item => (
            <List.Item className="incubator-list-item">
              <Link to={`/incubator/one/${item.uuid}/detail/bill`}>
                <Card>
                  <div className="banner">
                    <img src={item.logo} alt="" />
                  </div>
                  <div className="name">
                    <h4>{item.sort}</h4>
                    <h5>{item.name}</h5>
                  </div>
                  <Row>
                    <Col span={9}>
                      <Statistic title="管理工位" value={item.stationSum} suffix="个" />
                      <Statistic title="在租数" value={item.stationUsedSum} suffix="个" />
                      <Statistic
                        title="入驻率"
                        precision={2}
                        value={item.stationPer || 0}
                        suffix="%"
                      />
                      <Statistic title="均价(个月)" value={item.aveUnit || 0} suffix="元" />
                    </Col>
                    <Col
                      span={7}
                      style={{
                        borderLeft: '1px solid #ddd',
                        borderRight: '1px solid #ddd',
                        padding: '0 10px',
                        height: '196px',
                      }}
                    >
                      <Statistic title="管理地址" value={item.addressSum} suffix="个" />
                      <Statistic title="在租数" value={item.addressUsedSum} suffix="个" />
                      <Statistic
                        title="使用率"
                        precision={2}
                        value={item.addressPer || 0}
                        suffix="%"
                      />
                    </Col>
                    <Col span={8}>
                      <Statistic title="管理客户" value={item.customSum} suffix="个" />
                    </Col>
                  </Row>
                </Card>
              </Link>
            </List.Item>
          )}
        />
      </div>
    );
  }
}

export default connect(state => ({ data: state.incubator_list }))(Index);



// WEBPACK FOOTER //
// ./src/components/incubator/base/Index.js